export const S3URLFindRegex = /https:\/\/haries-img\.s3\.ap-northeast-2\.amazonaws\.com\/[^"'\s<>]*/;

export const S3URLInDocument = /!\[[^\]]+\]\([^)]+\)/g;